// extracted by mini-css-extract-plugin
export default {"button":"Buttons__button--3ne","demo":"Buttons__demo--nC4","play":"Buttons__play--3h1"};